/**
 * Card story — hover-to-play video.
 *
 * Ogni card correlata (.card-story con [data-story-card]) all'hover/focus avvia
 * il video muto e lo mette in pausa (ripartendo da 0) all'uscita. Su touch/no-
 * hover resta l'immagine in evidenza. Rispetta prefers-reduced-motion (niente
 * riproduzione automatica).
 *
 * Markup: template-parts/components/card-story.php ([data-story-card]).
 */
( function () {
	'use strict';

	const cards = document.querySelectorAll( '[data-story-card]' );
	if ( ! cards.length ) {
		return;
	}

	if ( window.matchMedia && window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
		return;
	}

	cards.forEach( ( card ) => {
		const video = card.querySelector( '.js-story-video' );
		if ( ! video ) {
			return;
		}

		const play = () => {
			const started = video.play();
			if ( started && typeof started.catch === 'function' ) {
				started.catch( () => {} ); // ignora l'eventuale rifiuto del browser
			}
		};

		const stop = () => {
			video.pause();
			video.currentTime = 0;
		};

		card.addEventListener( 'mouseenter', play );
		card.addEventListener( 'focusin', play );
		card.addEventListener( 'mouseleave', stop );
		card.addEventListener( 'focusout', stop );
	} );
}() );
